import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Options,LabelType } from '@angular-slider/ngx-slider';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-current',
  templateUrl: './current.component.html',
  styleUrls: ['./current.component.scss']
})
export class CurrentComponent implements OnInit {

  error:boolean=false;
  errorMessage = "";
  value: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100,
    step:0.1,
    translate: (value: number, label: LabelType): string => {
          return value+"%"
    }
  };

  currentPortfolioValue: any;
  newPortfolioValue: string;
  currentTaxBracket: any;
  newTaxBracket: any;
  currentCostOfLivingIncrease: any;
  newCostOfLivingIncrease: any;
  portfolio_value: any;
  tax_bracket: any;
  cost_of_living_increase: any;
  result: any;
  response: any;
  income_expense_response: any;
  have_statistic: any;
  need_statistic: any;
  isSaving:boolean=false;
  isVidLoading=true;

  constructor(private http:HttpClient,public user:UserService,private _http:HttpClient,private toastr:ToastrService,private _router:Router) { }

  ngOnInit() {
        // If the item is stored in a cookie retrieve that
        if (localStorage.getItem('current_allocation') != undefined){
          this.user.getAllocation(localStorage.getItem('current_allocation')).subscribe(result => {
            this.result = result;
          });
        }
        // else get the data from the database
        else {
          this._http.get( UserService.RESOURCES_PATH + '/data2.json').subscribe(result =>{
            this.result = result;
          });

        }
        this.user.currentPortfolioValue.subscribe(currentPortfolioValue => {
          this.currentPortfolioValue = currentPortfolioValue;
          this.newPortfolioValue = currentPortfolioValue;
        });
        this.user.currentTaxBracket.subscribe(currentTaxBracket => {
          this.currentTaxBracket = currentTaxBracket;
          this.newTaxBracket = currentTaxBracket;
          });
        this.user.currentCostOfLivingIncrease.subscribe(currentCostOfLivingIncrease => {
          this.currentCostOfLivingIncrease = currentCostOfLivingIncrease;
          this.newCostOfLivingIncrease = currentCostOfLivingIncrease;
        });
        if (localStorage.getItem('current_need_statistic') != undefined){
          this.user.getStatistic(localStorage.getItem('current_need_statistic')).subscribe(statistic =>{
              this.need_statistic = statistic;
          });
        }
        if (localStorage.getItem('current_have_statistic') != undefined){
          this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
              this.have_statistic = statistic;
          });
        }
  }

  calculatePercentage(category_id){
    // Update the asset
    // Find the category by the id
    let category = this.result.CATEGORIES.find( obj => obj.category_id == category_id);
    let percentage = 0.0;
    let total_percentage = 0.0;
    for (let i = 0; i < category.ASSETS.length; i++){
        percentage += parseFloat(category.ASSETS[i].asset_percentage);
    }
    category.category_percentage = percentage;
    for (let i = 0; i < this.result.CATEGORIES.length; i++){
        total_percentage += parseFloat(this.result.CATEGORIES[i].category_percentage);
    }
    this.result.percentage = total_percentage;
  }

  percentageError(){
    this.error = true;
    this.errorMessage = "Percentages don't add up to 100%!"
  }

  portfolioValueError(){
    this.error = true;
    this.errorMessage = "Portfolio value must be greater than zero!"
  }

  clearAllocation(){
    localStorage.removeItem('current_allocation');
    localStorage.removeItem('current_have_statistic');
    localStorage.removeItem('current_chipscore_id');
    localStorage.removeItem('allocated_amount')
    this.have_statistic = {};
    this.need_statistic = {};
    this.result.percentage = 0.0;
    this.result.CATEGORIES.forEach( category => {
      category.category_percentage = 0.0;
      category.ASSETS.forEach( asset => {
          asset.asset_percentage = 0.0;
      });
    });
    this.isSaving=false;
  }

  // Posting the allocation
  addAllocation(){
    if (this.result.percentage !== 100){
        this.percentageError();
        return
    }
    else if(Number(this.currentPortfolioValue) <= 0) {
        this.portfolioValueError();
        return
    }
    else{
      this.error = false;
      // Adds the html  elements
      var html = '';
      html += document.getElementById('allocation-table').innerHTML;
      // html += document.getElementById('need-vs-have-table').innerHTML;
      this.user.html_body += html;
      // Adds the income_expense
      // Testing with dummy data
      // posts the new income expense and get response
      let values=this.result.CATEGORIES.map((asset) =>asset.ASSETS.map(a=>a.asset_percentage !=0? (a.asset_percentage/100) * this.currentPortfolioValue : 0));
      let merged = [].concat.apply([], values);
      this.result.allocation=merged;
      this.result.portfolio_value = Number(this.currentPortfolioValue);
      this.isSaving=true;


      this.user.addAllocation(this.result).subscribe(response =>{
        // Gets the new response from POSTing the allocation
        this.response = response;
        this.toastr.success(response['message'],"CHIPSCORE");
        localStorage.removeItem('current_allocation');
        localStorage.setItem('current_allocation',this.response.createdAllocation._id);
        // localStorage.setItem('beta_avg',this.response.createdAllocation.beta)
        this.user.getAllocation(localStorage.getItem('current_allocation')).subscribe(result => {
          this.result = result;
          this.isSaving=false;
        },(error)=>{
          this.isSaving=false;
          this.toastr.error(error);
        });
        localStorage.removeItem('current_have_statistic');
        localStorage.setItem('current_have_statistic',this.response.statistics_id);
        this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
          this.have_statistic = statistic;
        });
        let body = [
          {
            "propName": "allocation_id",
            "value": this.response.createdAllocation._id
          },
          {
            "propName": "have_statistics_id",
            "value": this.response.statistics_id
          }
        ]
      },(error)=>{
        console.log(error)
        this.isSaving=false;
      })

    }
    this.addIncomeExpense();
    this.saveToLocal();
  }


  // Posting the income expense data
  addIncomeExpense(){
    // this.get_income_expenses_values();
    this.user.currentPortfolioValue.subscribe(result => {
        this.portfolio_value = Number(result);
    });
    this.user.currentTaxBracket.subscribe(result => {
        this.tax_bracket = Number(result);
    });
    this.user.currentCostOfLivingIncrease.subscribe(result => {
        this.cost_of_living_increase = Number(result);
    });

    var newIncomeExpense = {
        portfolio_value: this.portfolio_value,
        tax_bracket: this.tax_bracket,
        cost_of_living_increase: this.cost_of_living_increase,
    }

    this.user.addIncomeExpense(newIncomeExpense).subscribe(response =>{
        this.income_expense_response = response;

        localStorage.removeItem('current_income_expense');
        localStorage.setItem('current_income_expense', this.income_expense_response.createdIncome_Expense._id);

        var newSession = {
            income_expense_id: this.income_expense_response.createdIncome_Expense._id,
            need_statistics_id: this.income_expense_response.statistics_id
        }
    });


  }

  saveToLocal(){
    localStorage.removeItem('current_portfolio_allocation');
    let current_portfolio_allocation=this.result.CATEGORIES.filter(category=>category.category_percentage > 0);
    current_portfolio_allocation.forEach(cat=>cat.ASSETS=cat.ASSETS.filter(asset=>asset.asset_percentage));
    localStorage.setItem('current_portfolio_allocation',JSON.stringify(current_portfolio_allocation));
  }


  roundOfValue(value){
    return Math.round(value)
  }

  handlePercentage(action,ast,id){
      this.result.CATEGORIES.map(category=>{
        category.ASSETS.map(asset=>{
          if(asset.asset_name === ast.asset_name){
            let percent;
            if(action=='increase')
            {
              percent=(Number(asset.asset_percentage) + 0.1).toFixed(2);
            }
            else if(action=='decrease'){
              percent=(Number(asset.asset_percentage) - 0.1).toFixed(2);
            }
            return asset.asset_percentage = percent  ;
          }
        })
      })
    this.calculatePercentage(id)
  }


}
